/**
 * Victa Merchant Hub — page-level JS.
 * Loaded once from sections/lq_vh_hero.liquid.
 *
 * Responsibilities:
 *   - Mark <body> with .victa-ea-page so Inbox-suppression CSS skips this
 *     page (Inbox surfaces bottom-right on the hub only)
 *   - Smooth-scroll anchor links with offset for the standard site header
 *
 * Updates feed: server-rendered by sections/lq_vh_updates.liquid from the
 * hw_victa_update metaobject. No JS hydration needed.
 *
 * FAQ accordion is handled natively via <details> + <lq-accordion> custom element
 * (see assets/lq_accordion.js). No JS hook needed here.
 *
 * `noindex` meta is server-rendered by snippets/meta-tags.liquid (driven by the
 * page's `seo.hidden` metafield, with a handle-based fallback). Do NOT re-add a
 * JS-side injection here — crawlers that don't execute JS (Bing, link unfurlers,
 * AI scrapers) would miss it.
 */

(function () {
  document.body.classList.add('victa-ea-page');

  // Smooth-scroll anchor links (offset by fixed top bar height)
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var href = a.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  });

  // Shopify Inbox surfaces bottom-right on the hub via base.css scoping (the
  // global hide rule excludes body.victa-ea-page). The CTA in the Talk to us
  // card is intentionally a static button — there's no public API to open the
  // chat widget programmatically, and the bottom-right launcher is already the
  // intended entry point. A permanent helper note in sections/lq_vh_team.liquid
  // points the merchant to the corner.
})();
